/**
 * Checkbox field component
 * Boolean toggle with inline label and help text
 */

import React from 'react';
import { FieldSchema, ValidationResult, getHelpText } from '@/config/fieldConfig';

export interface CheckboxFieldProps {
  name: string;
  value: boolean;
  onChange: (value: boolean) => void;
  schema: FieldSchema;
  error?: ValidationResult;
  disabled?: boolean;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  name,
  value,
  onChange,
  schema,
  error,
  disabled = false,
}) => {
  const label = typeof schema.label === 'function' ? schema.label() : schema.label;
  const help = getHelpText(schema.help);

  return (
    <div className="field-wrapper">
      <label className="flex items-start cursor-pointer">
        <input
          id={`field-${name}`}
          type="checkbox"
          checked={value || false}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="
            mt-1 h-4 w-4 rounded border-gray-300 text-blue-600
            focus:ring-blue-500 focus:ring-2 focus:ring-offset-0
            disabled:cursor-not-allowed disabled:opacity-50
          "
        />
        <span className="ml-2 flex-1">
          <span className="text-sm font-medium text-gray-700">
            {label}
          </span>
          {help && (
            <span className="block text-xs text-gray-500 mt-0.5">
              {help}
            </span>
          )}
        </span>
      </label>

      {error && (
        <div className={`text-xs mt-1 ${error.isWarning ? 'text-yellow-600' : 'text-red-600'}`}>
          {error.message}
        </div>
      )}
    </div>
  );
};

export default CheckboxField;
